import { RouteRecordRaw } from 'vue-router'
import Layout from '@/layout/Index.vue'

const  orderRouter: Array<RouteRecordRaw> = [
    {
        path: '/order',
        name: '订单管理',
        component: Layout,
        meta: { title: '订单管理', icon: 'icon-horn', alwaysShow: true },
        children: [
            {
                path: 'movie-list',
                name: '电影订单',
                component: () => import('@/views/order/movie/List.vue'),
                meta: { title: '电影订单', badge: 'rule_auths' }
            },
            {
                path: 'movie-show',
                name: '电影订单详情-查看',
                component: () => import('@/views/order/movie/Detail.vue'),
                meta: { title: '电影订单详情-查看' }
            },
            {
                path: 'movie-edit',
                name: '电影订单详情-编辑',
                component: () => import('@/views/order/movie/Detail.vue'),
                meta: { title: '电影订单详情-编辑' }
            },
            {
                path: 'service-list',
                name: '客服订单中心',
                component: () => import('@/views/order/List.vue'),
                meta: { title: '客服订单中心' }
            },
            {
                path: 'list',
                name: '实物订单',
                component: () => import('@/views/order/List.vue'),
                meta: { title: '实物订单' }
            },
            {
                path: 'show',
                name: '实物订单详情-查看',
                component: () => import('@/views/order/Detail.vue'),
                meta: { title: '实物订单详情-查看' }
            },
            {
                path: 'edit',
                name: '实物订单详情-编辑',
                component: () => import('@/views/order/Detail.vue'),
                meta: { title: '实物订单详情-编辑' }
            },
            {
                path: 'store-list',
                name: '在线点单订单',
                component: () => import('@/views/order/store/List.vue'),
                meta: { title: '在线点单订单' }
            },
            {
                path: 'store-edit',
                name: '在线点单详情',
                component: () => import('@/views/order/store/Detail.vue'),
                meta: { title: '在线点单详情' }
            },
            {
                path: 'store-edit-saas',
                name: '在线点单详情-SaaS',
                component: () => import('@/views/order/store/SassSDetail.vue'),
                meta: { title: '在线点单详情-SaaS' }
            },
            {
                path: 'offline-list',
                name: '线下订单',
                component: () => import('@/views/order/OfflineList.vue'),
                meta: { title: '线下订单' }
            },
            {
                path: 'after-sale-list',
                name: '售后订单',
                component: () => import('@/views/order/after-sale/List.vue'),
                meta: { title: '售后订单' }
            },
            {
                path: 'refund',
                name: '订单退款',
                component: () => import('@/views/order/after-sale/Detail.vue'),
                meta: { title: '订单退款' }
            },
            {
                path: 'abnormal-list',
                name: '快递异常订单',
                component: () => import('@/views/order/AbnormalOrderList.vue'),
                meta: { title: '快递异常订单' }
            },
            {
                path: 'delay-list',
                name: '延迟订单',
                component: () => import('@/views/order/DelayList.vue'),
                meta: { title: '延迟订单' }
            },
            {
                path: 'coupon-list',
                name: '卡券订单',
                component: () => import('@/views/electron/AllOrderList.vue'),
                meta: { title: '卡券订单' }
            },
        ]
    }
]

export default orderRouter
